export default __webpack_public_path__ + "static/SRUS YT90 - Especification Del Producto y Datos Técnicos-7c818dd5cd929fe5f3a9b7f70e81e202.pdf";